import { BsModalService } from 'ngx-bootstrap/modal';
import { EventEmitterBaseService } from './core/services/event-emitter-service/event-emitter.service';
import { NotificacoesHubService } from './core/services/notificacoes/notificacoesHub.service';
import { Component, AfterViewInit, OnInit } from '@angular/core';
import { AuthService } from './services/auth.service';
import { AppService } from './services/app.service';
import * as RxjsOperators from 'rxjs/operators';
import { ModalNotificacoesComponent } from './components/modal-notificacoes/modal-notificacoes.component';
import { SessionService } from './core/services/session/session.service';
import { AppEvents } from './core/types/app-events';
import { CognitoService } from './core/services/cognito/cognito.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements AfterViewInit, OnInit {
  public displayNavigationBars: boolean = true;
  public loading: boolean;

  constructor(
    private authService: AuthService,
    private appService: AppService,
    private notificacoesHubService: NotificacoesHubService,
    private bsModalService: BsModalService,
    private session: SessionService,
    private cognito: CognitoService
  ) {
    this.listenToNotificationsModalOpenEvent();
    this.listenToEventHideApplicationNavigationBars();
    this.listenToEventDisplayApplicationNavigationBars();
  }

  public async ngOnInit(): Promise<void> {
    window.location.href.includes('login') ? this.session.logout() : (this.displayNavigationBars = true);
    if (!this.cognito.usuarioLogado()) {
      this.session.logout();
      await this.cognito.deslogar();
      return;
    }

    const cognitoTokenValido = await this.cognito.refreshTokenValido();
    if (cognitoTokenValido) {
      await this.cognito.atualizarSessaoCognito();
      return;
    }
  }

  public async ngAfterViewInit() {
    if (!window.location.href.includes('login')) {
      await this.notificacoesHubService.startHub();
    }

    this.authService.showLoadingEmitter
      .pipe(
        RxjsOperators.startWith(false),
        RxjsOperators.delay(0),
        RxjsOperators.tap((loading: any) => {
          this.loading = loading;
        })
      )
      .subscribe();
  }

  public getClasses() {
    return {
      'pinned-sidebar': this.appService.getSidebarStat().isSidebarPinned,
      'toggeled-sidebar': this.appService.getSidebarStat().isSidebarToggeled,
    };
  }

  public toggleSidebar() {
    this.appService.toggleSidebar();
  }

  private listenToNotificationsModalOpenEvent() {
    EventEmitterBaseService.get('openNotificationsModal').subscribe(() => {
      this.bsModalService.show(ModalNotificacoesComponent, { class: 'modal-md' });
    });
  }

  private listenToEventHideApplicationNavigationBars() {
    EventEmitterBaseService.get(AppEvents.hideApplicationNavigationBars).subscribe(() => {
      this.displayNavigationBars = false;
    });
  }

  private listenToEventDisplayApplicationNavigationBars(): void {
    EventEmitterBaseService.get(AppEvents.displayApplicationNavigationBars).subscribe(() => {
      this.displayNavigationBars = true;
    });
  }
}
